import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { StudentLoginCard } from "@/components/StudentLoginCard";
import { usePillars } from "@/contexts/PillarsContext";
import { BG_STYLES } from "@/pages/WelcomePage";

export default function StudentLoginPage() {
  const { settings } = usePillars();
  const logoUrl = settings?.logo_url;
  const brandName = settings?.cover_title || "The Self-Agency Project";
  const pageBgStyle = settings?.cover_background_url
    ? { backgroundImage: `linear-gradient(rgba(220,222,226,0.55), rgba(220,222,226,0.85)), url(${settings.cover_background_url})`, backgroundSize: "cover", backgroundPosition: "center" }
    : (BG_STYLES[settings?.cover_background_style] || BG_STYLES.granite);

  return (
    <div className="min-h-screen px-5 py-10 grid place-items-center" style={pageBgStyle}>
      <motion.div
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
        className="w-full max-w-md flex flex-col gap-4"
        data-testid="student-login-page"
      >
        <div className="flex items-center justify-center gap-3">
          {logoUrl && <img src={logoUrl} alt="" className="h-10 w-auto max-w-[130px] object-contain" />}
          <span className="font-display font-bold text-lg">{brandName}</span>
        </div>
        <StudentLoginCard />
        <div className="text-center text-sm text-[#000000]">
          Not a school student?{" "}
          <Link data-testid="staff-login-link" to="/login" className="text-[#3F6212] font-semibold underline-offset-2 hover:underline">Staff & public sign-in</Link>
        </div>
      </motion.div>
    </div>
  );
}
